var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 12.3633L11.0742 9.62891C10.9375 9.51953 10.7734 9.4375 10.6094 9.4375H10.1719C10.9102 8.48047 11.375 7.27734 11.375 5.9375C11.375 2.82031 8.80469 0.25 5.6875 0.25C2.54297 0.25 0 2.82031 0 5.9375C0 9.08203 2.54297 11.625 5.6875 11.625C7 11.625 8.20312 11.1875 9.1875 10.4219V10.8867C9.1875 11.0508 9.24219 11.2148 9.37891 11.3516L12.0859 14.0586C12.3594 14.332 12.7695 14.332 13.0156 14.0586L13.7812 13.293C14.0547 13.0469 14.0547 12.6367 13.8086 12.3633ZM5.6875 9.4375C3.74609 9.4375 2.1875 7.87891 2.1875 5.9375C2.1875 4.02344 3.74609 2.4375 5.6875 2.4375C7.60156 2.4375 9.1875 4.02344 9.1875 5.9375C9.1875 7.87891 7.60156 9.4375 5.6875 9.4375Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.765349f40cc67d6ab80891b25ce94855.svg";
export { ForwardRef as ReactComponent };